<template>
  <div>
    <b-row>
      <b-col class="mx-auto" cols="12" sm="10">
        <b-container>
          <b-button v-if="!viewAdd && !viewEdit" class="button btn-blue my-4" @click="addPressed">
            <font-awesome-icon icon="plus" /> <span>{{ $t(addNewText) }}</span>
          </b-button>

          <b-button
            v-if="!viewAdd && !viewEdit"
            class="button btn-blue ml-5 my-4"
            :disabled="importPorgress != 0 ? true : false"
            @click="$refs.importFile.click()"
          >
            {{ $t("general.Import") }} <font-awesome-icon icon="upload" />
            <input ref="importFile" type="file" hidden accept=".xls" @change="importOnChange" />
            <xlsx-read :file="xlsxFile">
              <xlsx-json :options="{ defval: null, blankrows: true }" @parsed="importOnParsed" />
            </xlsx-read>
            <b-progress v-if="importPorgress != 0" :max="100" show-progress animated>
              <b-progress-bar
                variant="dark"
                :value="importPorgress"
                :label="`${importPorgress}%`"
              ></b-progress-bar>
            </b-progress>
          </b-button>

          <b-button
            v-if="!viewAdd && !viewEdit && buildingOwnersItems.length > 0"
            class="button btn-green ml-5 my-4"
            @click="exportBuildingOwners"
          >
            {{ $t("general.Export") }} <font-awesome-icon icon="download" />
          </b-button>

          <b-button
            v-if="
              !viewAdd &&
              !viewEdit &&
              building.meetings.length == 0 &&
              buildingOwnersItems.length > 0
            "
            class="button btn-red ml-5 my-4"
            @click="deleteAllBuildingOwners"
          >
            <span>{{ $t("dt_building_owner_delete_all") }}</span>
            <font-awesome-icon class="ml-2" icon="trash-alt" />
          </b-button>
        </b-container>

        <b-row>
          <b-col>
            <appBuildingOwner
              v-if="viewAdd"
              :is-new="true"
              :building-id="building.id"
              :all-countries="allCountries"
              :buildings-asl="buildings"
              @cancel="cancelPressed"
            />
            <appBuildingOwner
              v-else-if="viewEdit"
              :is-new="false"
              :building-owner-id="buildingOwnerId"
              :building-id="building.id"
              :all-countries="allCountries"
              :buildings-asl="buildings"
              @cancel="cancelPressed"
            />
          </b-col>
        </b-row>

        <b-row v-if="!viewAdd && !viewEdit" align-h="between" class="mb-4">
          <b-col cols="3">
            <div>
              <label for="input">Rechercher</label>
              <b-input-group>
                <template #append>
                  <b-input-group-text
                    v-if="!hasSearchInputBeenReseted || isSearchInputFocused || searchParams"
                    type="button"
                    @click="resetSearch"
                  >
                    <font-awesome-icon icon="times" size="sm"></font-awesome-icon>
                  </b-input-group-text>
                </template>

                <b-form-input
                  id="input"
                  v-model="searchParams"
                  placeholder="Tapez pour rechercher"
                  @focus="focusSearch"
                  @blur="unfocusSearch"
                  @keyup.enter="search"
                />
              </b-input-group>
              <small class="text-secondary"
                >Recherche par nom ou numéro de lot <br />
                Utilisez la touche Entrée pour lancer la recherche</small
              >
            </div>
          </b-col>
          <b-col v-if="totalRowsBuildingOwners > 0" cols="2">
            <label for="per-page">per page</label>
            <b-form-select
              id="per-page"
              v-model="pagination.pageSize"
              class="numPerPage"
              :options="pageOptionsBuildingOwners"
              @change="onChangePaginator"
            ></b-form-select>
          </b-col>
        </b-row>

        <b-row v-if="!viewAdd && !viewEdit">
          <b-col>
            <b-table
              id="step5-building-owners"
              ref="step5Table"
              striped
              hover
              sort-icon-left
              :sort-by.sync="sortBy"
              :fields="buildingOwnersFields"
              :items="buildingOwnersItems"
              :per-page="pagination.pageSize"
              :busy="isLoading"
              responsive="sm"
            >
              <!-- Heads -->
              <template #head(name)>
                <div class="d-flex align-items-center">
                  <span class="mr-2" @click="setSort('lastname')">Nom</span>
                  <font-awesome-icon
                    v-if="
                      tableHeaderSettings.sort.by == 'lastname' &&
                      tableHeaderSettings.sort.dir == 'desc'
                    "
                    icon="sort-up"
                    @click="setSort('lastname', 'asc')"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else-if="
                      tableHeaderSettings.sort.by == 'lastname' &&
                      tableHeaderSettings.sort.dir == 'asc'
                    "
                    icon="sort-down"
                    @click="setSort('lastname', 'desc')"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    icon="sort"
                    @click="setSort('lastname')"
                  ></font-awesome-icon>
                </div>
              </template>

              <template #head(email)>
                <div class="d-flex align-items-center">
                  <span class="mr-2" @click="setSort('email')">Email</span>
                  <font-awesome-icon
                    v-if="
                      tableHeaderSettings.sort.by == 'email' &&
                      tableHeaderSettings.sort.dir == 'desc'
                    "
                    icon="sort-up"
                    @click="setSort('email', 'asc')"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else-if="
                      tableHeaderSettings.sort.by == 'email' &&
                      tableHeaderSettings.sort.dir == 'asc'
                    "
                    icon="sort-down"
                    @click="setSort('email', 'desc')"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    icon="sort"
                    @click="setSort('email')"
                  ></font-awesome-icon>
                </div>
              </template>

              <template #cell(index)="data">
                {{ pageIncrementalIndex + data.item.index }}
              </template>
              <template #cell(name)="data">
                <div v-if="isAsl" class="small d-flex align-items-center">
                  <span>Volume: </span>
                  <router-link
                    v-if="data.item.building_asl_id"
                    :to="{
                      name: 'edit-building',
                      params: { id: data.item.building_asl_id, step: 5 },
                    }"
                    target="_blank"
                    class="ml-1"
                    title="Voir les copropriétaires du volume (nouvel onglet)"
                  >
                    {{ getBuildingAslName(data.item.building_asl_id) }}
                    <font-awesome-icon icon="external-link-alt" size="sm" class="ml-1" />
                  </router-link>
                  <span v-else>{{ getBuildingAslName(data.item.building_asl_id) }}</span>
                </div>
                {{ data.item.gender }}
                {{ data.item.name }}
                {{ data.item.firstname }}
                <div>
                  <span v-if="getRecipientsData(data.item.id).length > 0" class="small">{{
                    "Autre destinataire: "
                  }}</span>
                  {{
                    getRecipientsData(data.item.id)[0]
                      ? getRecipientsData(data.item.id)[0].firstname +
                        " " +
                        getRecipientsData(data.item.id)[0].lastname
                      : getRecipientsData(data.item.id)[0]
                  }}
                  <!-- NOTE: Show username and password  -->
                  <div>
                    <span class="small">{{ "Nom d'utilisateur: " }}</span>
                    <span>{{ data.item.username }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="small">{{ "Le mot de passe:" }}</span>
                    <appUserPasswordBlock
                      class="ml-2"
                      :password="data.item.password"
                      :show-password="data.item.showPassword"
                      @toggleShowPassword="data.item.showPassword = !data.item.showPassword"
                    />
                  </div>
                </div>
              </template>
              <template #cell(lreAgreement)="data">
                <div v-if="getLreRefusal(data.item.id)" class="text-center text-danger">
                  <font-awesome-icon icon="ban" size="2x" />
                  <div class="font-weight-bold small">Refus LRE</div>
                </div>
                <div
                  v-else-if="getLreAgreement(data.item.id)"
                  class="text-center text-success"
                  type="button"
                  @click="toggleBuildingOwnerLreAgreement(data.item.id, false)"
                >
                  <font-awesome-icon icon="check-circle" size="2x" />
                  <div class="font-weight-bold small">Consentement LRE</div>
                </div>
                <div
                  v-else
                  class="text-center text-muted"
                  type="button"
                  @click="toggleBuildingOwnerLreAgreement(data.item.id, true)"
                >
                  <font-awesome-icon icon="times-circle" size="2x" />
                  <div class="font-weight-bold small">Pas de réponse</div>
                </div>
              </template>
              <!-- Parts Column -->
              <template #thead-top="">
                <b-tr>
                  <b-th colspan="2"></b-th>
                  <b-th class="text-center">
                    <div
                      class="bg-color-blue color-white rounded"
                      type="button"
                      @click="checkAllLreConsent"
                    >
                      Activer tout
                    </div>
                  </b-th>
                  <b-th
                    class="text-center"
                    variant="primary"
                    :colspan="totalVotingCategories ? totalVotingCategories : 1"
                  >
                    <div>
                      Catégories de vote
                    </div>
                  </b-th>
                  <b-th />
                  <b-th />
                </b-tr>
              </template>
              <template #custom-foot="">
                <b-tr>
                  <b-th colspan="3" class="text-right text-uppercase align-middle">
                    Total Tantièmes :
                  </b-th>
                  <b-th
                    v-for="category in listOfTotalTantiemesPerVoteCategory"
                    :key="category.voting_category_slug"
                    variant="primary"
                    class="text-center"
                  >
                    {{ category.voting_category_name }}
                    <b-badge variant="danger" class="bo-parts-total mr-1" pill>
                      {{ category.parts }}
                    </b-badge>
                  </b-th>
                  <b-th class="text-uppercase text-center">
                    Grand Total :
                    <b-badge variant="danger" class="bo-parts-total mr-1" pill
                      >{{ totalPartsPerBuilding }}
                    </b-badge>
                  </b-th>
                  <b-th />
                </b-tr>
              </template>
              <template #cell(parts)="data">
                <b-badge variant="danger" class="bo-parts-total mr-1" pill>
                  {{ totalPartsPerBuildingOwner(data.item.parts) }}
                </b-badge>

                <b-button class="btn btn-sm btn-edit tablebutton" @click="data.toggleDetails">
                  <font-awesome-icon icon="info-circle" size="2x" />
                </b-button>
              </template>
              <template #row-details="data">
                <b-card>
                  <b-row class="justify-content-md-center">
                    <b-col cols="5">
                      <h6
                        v-for="category in buildingOwnersFields.slice(3, 3 + totalVotingCategories)"
                        :key="category.key"
                      >
                        {{ category.label }}
                        <b-list-group v-for="part in data.item.parts" :key="part.id">
                          <b-list-group-item
                            v-if="part.categoryId == category.id"
                            class="d-flex justify-content-between align-items-center"
                          >
                            <span>
                              Lot :
                              <b-badge variant="primary" class="bo-lot" pill>
                                {{ part.lot }}
                              </b-badge>
                            </span>
                            <span>
                              Tantième :
                              <b-badge variant="danger" class="bo-parts" pill>
                                {{ part.parts }}
                              </b-badge>
                            </span>
                          </b-list-group-item>
                        </b-list-group>
                      </h6>
                    </b-col>
                  </b-row>
                </b-card>
              </template>
              <template #cell(actions)="data">
                <b-button
                  class="btn btn-sm btn-edit tablebutton text-info"
                  title="Réinitialiser le mot de passe"
                  @click="openModalAGResetUserPassword(data.item.username)"
                >
                  <font-awesome-icon icon="lock" size="2x" />
                </b-button>
                <b-button
                  v-if="getRecipientsData(data.item.id).length == 0"
                  class="btn btn-sm btn-edit tablebutton"
                  title="Ajouter une autre destinataire"
                  @click="addOrEditAddRecipient(data.item.id)"
                >
                  <font-awesome-icon icon="user-plus" size="2x" />
                </b-button>
                <b-button
                  v-if="getRecipientsData(data.item.id).length > 0"
                  class="btn btn-sm btn-edit tablebutton"
                  title="Éditer un destinataire"
                  @click="addOrEditAddRecipient(data.item.id)"
                >
                  <font-awesome-icon icon="user-edit" size="2x" />
                </b-button>
                <b-button
                  class="btn btn-sm btn-edit tablebutton"
                  title="Modifier la copropriétaire"
                  @click="editPressed(data.item.id)"
                >
                  <font-awesome-icon icon="pen" size="2x" />
                </b-button>
                <b-button
                  class="btn btn-sm btn-edit tablebutton"
                  title="Supprimer la copropriétaire"
                  @click="deletePressed(data.item.id)"
                >
                  <font-awesome-icon icon="trash-alt" size="2x" />
                </b-button>
                <b-button
                  class="btn btn-edit tablebutton"
                  title="Changer le propriétaire"
                  @click="openModalDepartBuildingLot(data.item.id)"
                >
                  <font-awesome-icon icon="sign-out-alt" size="2x" />
                </b-button>
              </template>
              <template #table-busy>
                <appIsLoading />
              </template>
            </b-table>
          </b-col>
        </b-row>
        <appLoader v-if="!viewAdd && !viewEdit && totalRowsBuildingOwners == 0 && isLoading" />

        <b-row v-if="!viewAdd && !viewEdit && totalRowsBuildingOwners > 0" align-h="center">
          <b-col cols="6" class="d-flex justify-content-center">
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.rowCount"
              :per-page="pagination.pageSize"
              aria-controls="mt-table"
              @input="onChangePaginator"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Modals -->
    <b-modal id="modal-required-columns-on-import" hide-footer size="lg" no-close-on-backdrop>
      <modalRequiredColumnsOnImport
        :required-columns-on-import="requiredColumnsOnImport"
        :imported-file-header-columns="importedFileHeaderColumns"
        :building-id="building.id"
        :invalid-country-codes="invalidCountryCodes"
        :invalid-contact-types="invalidContactTypes"
        :invalid-gender-types="invalidGenderTypes"
        :invalid-entity-types="invalidEntityTypes"
        @closeModalReqCols="closeModalReqCols"
        @IMPORT="IMPORT"
      />
    </b-modal>
    <b-modal id="modal-depart-building-lot" hide-footer size="lg">
      <template #modal-title>
        <div>Changer le propriétaire</div>
      </template>
      <modalDepartBuildingLot
        :items="buildingOwnersItems"
        :building-owner-id="buildingOwnerId"
        :building-id="building.id"
        @refetchTableData="refetchTableDataAfterDepartBuildingLot"
      />
    </b-modal>
    <b-modal id="modal-add-recipient" hide-footer size="lg">
      <template #modal-title>
        <div>Ajouter un destinataire</div>
      </template>
      <modalAddRecipient
        :building-owner-id="buildingOwnerId"
        :building-id="building.id"
        @closeModal="closeModalAddRecipient"
      />
    </b-modal>
    <b-modal id="modal-ag-reset-user-password" hide-footer size="lg">
      <template #modal-title>
        <div>Réinitialiser le mot de passe</div>
      </template>
      <modalAGResetUserPassword
        :username="buildingOwnerUsername"
        :user-type="'building-owner'"
        @closeModal="closeModalAGResetUserPassword"
        @userPasswordReseted="userPasswordReseted"
      />
    </b-modal>
  </div>
</template>

<script>
import appBuildingOwner from "./building-owners/BuildingOwner";

import { XlsxRead, XlsxJson /* XlsxTable */ } from "vue-xlsx/dist/vue-xlsx.es.js";
import modalRequiredColumnsOnImport from "@/components/modals/RequiredColumnsOnImport";
import modalDepartBuildingLot from "@/components/modals/departure-buildingOwner/DepartBuildingLot";
import modalAddRecipient from "@/components/modals/AddRecipient";
import modalAGResetUserPassword from "@/components/modals/AGResetUserPassword";
import appUserPasswordBlock from "@/components/snippets/UserPasswordBlock";

import BuildingOwnerMW from "@/middlewares/BuildingOwner";
import BuildingLotMW from "@/middlewares/BuildingLot";
import VotingCategoryMW from "@/middlewares/VotingCategory";
import BuildingOwnerBuildingLotORM from "@/store/orm-axios/models/BuildingOwnerBuildingLot";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import VueJwtDecode from "vue-jwt-decode";
import RecipientORM from "@/store/orm-axios/models/Recipient";
import RecipientMW from "@/middlewares/Recipient";
import BuildingORM from "@/store/orm-axios/models/Building";

export default {
  components: {
    XlsxRead,
    XlsxJson,
    modalRequiredColumnsOnImport,
    appBuildingOwner,
    modalDepartBuildingLot,
    modalAddRecipient,
    modalAGResetUserPassword,
    appUserPasswordBlock,
    appIsLoading: () => import("@/components/snippets/IsLoading"),
  },
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      viewAdd: false,
      viewEdit: false,
      isLoading: true,
      xlsxFile: null,
      xlsxData: null,
      pageOptionsBuildingOwners: [10, 20, 50, 100],
      sortBy: "name",
      totalRowsBuildingOwners: 0,
      totalVotingCategories: 1,
      buildingOwnersFields: [
        { key: "index", label: "Indice" },
        { key: "name", label: "Nom" },
        { key: "lreAgreement", label: "Consentement à la LRE" },
        { key: "email", label: "Email" },
        { key: "parts", label: "Total Tantième" },
        { key: "actions", label: "Options" },
      ],
      buildingOwnersItems: [],
      buildingOwnerId: null,
      buildingOwnerUsername: null,
      votingCategories: [],
      buildingOwners: [],
      buildingLots: [],
      requiredColumnsOnImport: {
        "*voting_categories*": [],
        "*building_lot*": null,
        // ..
        lastname: null,
        firstname: null,
        gender: null,
        email: null,
        address: null,
        complement: null,
        complement_2: null,
        zipcode: null,
        city: null,
        country: null,
        contact_type: null,
        entity_type: null,
        // ???: ..
        // "number",
        // "phone",
        // "*building_lot_category*"
      },
      importedFileHeaderColumns: [],
      invalidCountryCodes: [],
      invalidContactTypes: [],
      invalidGenderTypes: [],
      invalidEntityTypes: [],

      searchParams: "",
      isSearchInputFocused: false,
      hasSearchInputBeenReseted: true,
      buildings: [],
      pagination: {
        page: 1,
        pageSize: 10,
        rowCount: 0,
        pageCount: 0,
      },
      tableHeaderSettings: {
        sort: {
          by: "lastname",
          dir: "asc",
        },
      },
      listOfTotalTantiemesPerVoteCategory: [],
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    importPorgress() {
      let mercureImportLive = this.$store.state.importBuildingOwners;

      if (mercureImportLive != undefined) {
        let userId = VueJwtDecode.decode(mercureImportLive.token).userId;
        if (userId == localStorage.getItem("userId")) {
          return mercureImportLive.import_progress;
        }
        return importPorgress;
      }
      return 0;
    },
    computedBuildingOwners() {
      return BuildingOwnerORM.query()
        .where("building_id", this.building.id)
        .withAllRecursive(2)
        .get();
    },
    computedBuildingOwnerBuildingLots() {
      return BuildingOwnerBuildingLotORM.all();
    },
    allCountries() {
      return this.$store.getters.getCountries;
    },
    recipients() {
      return RecipientORM.query().where("building_id", this.building.id).get();
    },
    addNewText() {
      if (this.building.asl) {
        return "general.New_Volume";
      } else {
        return "general.New_Copropriétaire";
      }
    },
    isAsl() {
      return this.$route.path.includes("asl");
    },
    pageIncrementalIndex() {
      return (this.pagination.page - 1) * this.pagination.pageSize;
    },
    totalPartsPerBuilding() {
      let count = 0;
      for (const votingCategory of this.listOfTotalTantiemesPerVoteCategory) {
        count = count + votingCategory.parts;
      }
      return count;
    },
  },
  watch: {
    importPorgress(val) {
      if (val == 100) {
        this.loadBuildingOwners();
        setTimeout(() => {
          this.$store.commit("setImportBuildingOwners", undefined);
        }, 3000);
      }
    },
    viewAdd(val) {
      this.$emit("hideParentActionButtons", val);
    },
    viewEdit(val) {
      this.$emit("hideParentActionButtons", val);
    },
  },
  beforeDestroy() {
    this.$emit("hideParentActionButtons", false);
  },
  created() {
    this.loadBuildingOwners();
  },
  mounted() {
    // event listener for modal hide ...
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "modal-required-columns-on-import") {
        this.xlsxFile = null;
        this.importedFileHeaderColumns = [];
        this.invalidCountryCodes = [];
        this.invalidContactTypes = [];
        this.invalidGenderTypes = [];
        this.invalidEntityTypes = [];
        if (this.$refs.importFile) this.$refs.importFile.value = null;
      }
    });
  },
  methods: {
    async loadBuildingOwners() {
      this.isLoading = true;

      try {
        await this.getBuildingOwnersPerPage();
        await this.makeApiCalls();

        if (this.isAsl) {
          await this.getBuildingsList();
        }
        this.processAndSetTableNeededData();
        this.setVotingCategoriesColumns();
      } catch (err) {
        console.error(err);
      }

      this.isLoading = false;
    },

    async onChangePaginator() {
      this.isLoading = true;
      await this.getBuildingOwnersPerPage();
      this.processAndSetTableNeededData();
      this.isLoading = false;
    },

    async getBuildingOwnersPerPage() {
      let queryParams = this.prepareQueryParams();
      await BuildingOwnerMW.QUERY_FETCH_FOR_BUILDING_CATALOG(queryParams).then(res => {
        let totalItems = res.response.data["hydra:totalItems"];
        this.pagination.rowCount = totalItems;
        this.tableData = res.response.data["hydra:member"];
      });
    },

    async setSort(by, dir) {
      if (!dir) {
        if (this.tableHeaderSettings.sort.dir == "asc") {
          dir = "desc";
        } else {
          dir = "asc";
        }
      }
      this.tableHeaderSettings.sort.by = by;
      this.tableHeaderSettings.sort.dir = dir;

      this.isLoading = true;
      await this.getBuildingOwnersPerPage();
      this.processAndSetTableNeededData();
      this.isLoading = false;
    },

    async makeApiCalls() {
      await BuildingOwnerMW.GET_TOTAL_VOTING_RIGHT_PARTS(this.building.id).then(res => {
        let sortedVotingCategories = this.$_.sortBy(res["hydra:member"], item => {
          return item.voting_category_slug;
        });
        this.listOfTotalTantiemesPerVoteCategory = sortedVotingCategories;
      });
      await RecipientMW.GET_BY_BUILDING_ID(this.building.id);
    },

    prepareQueryParams() {
      var queryParams = {
        sort: {},
        buildingId: this.building.id,
        page: this.pagination.page,
        itemsPerPage: this.pagination.pageSize,
        searchParams: this.searchParams,
      };
      if (this.tableHeaderSettings.sort.by && this.tableHeaderSettings.sort.dir) {
        queryParams.sort["by"] = this.tableHeaderSettings.sort.by;
        queryParams.sort["dir"] = this.tableHeaderSettings.sort.dir;
      }
      return queryParams;
    },

    processAndSetTableNeededData() {
      this.setBuildingOwnersData();
      this.setBuildingLotsData();
      this.setVotingCategoriesData();

      this.iterateThroughBuildingOwnersAndSetNeededData(this.buildingOwners);
    },
    setBuildingOwnersData() {
      this.buildingOwners = BuildingOwnerORM.query().where("building_id", this.building.id).get();
      this.totalRowsBuildingOwners = this.buildingOwners.length;
    },
    setBuildingLotsData() {
      this.buildingLots = BuildingLotORM.query()
        .where("building_id", this.building.id)
        .with("building_owner_building_lots.building_owner_voting_rights")
        .get();
    },
    setVotingCategoriesData() {
      this.votingCategories = VotingCategoryORM.query()
        .where("building_id", this.building.id)
        .get();
      this.totalVotingCategories = this.votingCategories.length;
    },
    iterateThroughBuildingOwnersAndSetNeededData(buildingOwners) {
      this.buildingOwnersItems = [];

      let sortedBuildingOwners = this.$_.sortBy(buildingOwners, bo => {
        return bo.lastname.toUpperCase();
      });
      sortedBuildingOwners.forEach((buildingOwner, buildingOwnerIndex) => {
        let boLots = [];
        this.buildingLots.forEach(buildingLot => {
          let buildingOwnerBuildingLots = buildingLot.building_owner_building_lots;
          buildingOwnerBuildingLots.forEach(buildingOwnerBuildingLot => {
            if (buildingOwnerBuildingLot.building_owner_id == buildingOwner.id) {
              let buildingOwnerVotingRights = buildingOwnerBuildingLot.building_owner_voting_rights;
              buildingOwnerVotingRights.forEach(buildingOwnerVotingRight => {
                boLots.push({
                  lot: buildingLot.name,
                  parts: buildingOwnerVotingRight.parts,
                  categoryId: buildingOwnerVotingRight.voting_category_id,
                  buildingLotId: buildingLot.id,
                });
              });
            }
          });
        });

        const gender = this.genderOptions.find(opt => opt.value == buildingOwner.gender);

        let boObj = {
          index: buildingOwnerIndex + 1,
          id: buildingOwner.id,
          gender: buildingOwner.gender && gender ? gender.text : "",
          name: buildingOwner.lastname,
          firstname: buildingOwner.firstname,
          email: buildingOwner.email,
          username: buildingOwner.username,
          password: buildingOwner.password,
          showPassword: false,
          parts: boLots,
          building_id: this.building.id,
          building_asl_id: buildingOwner.building_asl_id,
        };

        this.votingCategories.forEach(votingCategory => {
          let boParts = 0;

          boLots.forEach(boLot => {
            if (boLot.categoryId == votingCategory.id) {
              boParts += boLot.parts;
            }
          });
          boObj[votingCategory.slug] = boParts;
        });

        this.buildingOwnersItems.push(boObj);
      });
    },

    setVotingCategoriesColumns() {
      let newVotingCategories = this.$_.filter(this.votingCategories, votingCategory => {
        return !this.$_.find(this.buildingOwnersFields, boField => {
          return votingCategory.id == boField.id;
        });
      });

      newVotingCategories = this.$_.sortBy(newVotingCategories, item => {
        return item.slug;
      }).reverse();

      newVotingCategories.forEach(votingCategory => {
        // dinamicaly insert "Voting Categories" in table after 3 column
        this.buildingOwnersFields.splice(3, 0, {
          id: votingCategory.id,
          key: votingCategory.slug,
          label: votingCategory.name,
        });
      });
    },

    totalPartsPerColumn(categoryId) {
      let sum = 0;
      this.buildingOwnersItems.forEach(bo => {
        bo.parts.forEach(part => {
          if (part.categoryId == categoryId) {
            sum += part.parts;
          }
        });
      });
      return sum;
    },
    importOnChange(e) {
      let xls = "application/vnd.ms-excel";
      e.target.files.forEach(file => {
        if (!file.type.includes(xls)) {
          this.$bvToast.toast("Seul le format XLS est accepté !", {
            title: "Erreur d'importation",
            variant: "danger",
            solid: true,
            autoHideDelay: 10000,
          });
        } else {
          this.xlsxFile = e.target.files ? e.target.files[0] : null;
        }
      });
    },
    importOnParsed(e) {
      this.xlsxData = e;
      // create array with header columns
      this.$_.each(e[0], (item, key) => {
        // Prevent from inserting __EMPTY keys in array
        if (!key.includes("__EMPTY")) {
          this.importedFileHeaderColumns.push(key);
        }
      });

      // open popup
      this.$bvModal.show("modal-required-columns-on-import");
    },
    closeModalReqCols() {
      this.$bvModal.hide("modal-required-columns-on-import");
    },
    async IMPORT() {
      this.$bvModal.hide("modal-required-columns-on-import");
      this.invalidCountryCodes = [];
      if (this.xlsxData !== null) {
        let buildingOwners = [];
        this.xlsxData.forEach(xlsxDataItem => {
          // NOTE: BuildingOwner is unique by firstname and lastname
          let bOwnerNameExists = buildingOwners.some(
            bOwner =>
              (!bOwner.firstname &&
                bOwner.lastname === xlsxDataItem[this.requiredColumnsOnImport["lastname"]]) ||
              (bOwner.firstname &&
                bOwner.lastname === xlsxDataItem[this.requiredColumnsOnImport["lastname"]] &&
                bOwner.firstname === xlsxDataItem[this.requiredColumnsOnImport["firstname"]])
          );
          if (!bOwnerNameExists && xlsxDataItem[this.requiredColumnsOnImport["lastname"]] != null) {
            let boVotingCategories = [];
            this.requiredColumnsOnImport["*voting_categories*"].forEach(bOwnerVC => {
              boVotingCategories.push({
                already_exists: bOwnerVC.already_exists,
                doc_table_column: bOwnerVC.doc_table_column,
                id: bOwnerVC.id,
                is_charge_generale: bOwnerVC.is_charge_generale,
                name: bOwnerVC.name,
              });
            });

            let boBuildingLots = [];
            this.xlsxData.forEach(e => {
              if (
                (!e[this.requiredColumnsOnImport["firstname"]] &&
                  e[this.requiredColumnsOnImport["lastname"]] ===
                    xlsxDataItem[this.requiredColumnsOnImport["lastname"]]) ||
                (e[this.requiredColumnsOnImport["firstname"]] &&
                  e[this.requiredColumnsOnImport["lastname"]] ===
                    xlsxDataItem[this.requiredColumnsOnImport["lastname"]] &&
                  e[this.requiredColumnsOnImport["firstname"]] ===
                    xlsxDataItem[this.requiredColumnsOnImport["firstname"]])
              ) {
                let boBuildingLotsParts = [];
                boVotingCategories.forEach(v => {
                  boBuildingLotsParts.push({
                    name: v.name,
                    parts: e[v.doc_table_column],
                  });
                });

                boBuildingLots.push({
                  lot: e[this.requiredColumnsOnImport["*building_lot*"]],
                  parts: boBuildingLotsParts,
                });
              }
            });
            this.checkCountry(xlsxDataItem);

            // Check if gender is valid
            let gender = this.checkGender(xlsxDataItem);

            // Check if contact_type is valid
            let contact_type = this.checkContactType(xlsxDataItem);

            // Check if entity_type is valid
            let entity_type = this.checkEntityType(xlsxDataItem);

            buildingOwners.push({
              firstname: xlsxDataItem[this.requiredColumnsOnImport["firstname"]],
              lastname: xlsxDataItem[this.requiredColumnsOnImport["lastname"]]
                ? xlsxDataItem[this.requiredColumnsOnImport["lastname"]]
                : null,
              gender: gender,
              email: xlsxDataItem[this.requiredColumnsOnImport["email"]]
                ? xlsxDataItem[this.requiredColumnsOnImport["email"]]
                : null,
              address: xlsxDataItem[this.requiredColumnsOnImport["address"]]
                ? xlsxDataItem[this.requiredColumnsOnImport["address"]]
                : null,
              complement: xlsxDataItem[this.requiredColumnsOnImport["complement"]],
              complement_2: xlsxDataItem[this.requiredColumnsOnImport["complement_2"]],
              city: xlsxDataItem[this.requiredColumnsOnImport["city"]]
                ? xlsxDataItem[this.requiredColumnsOnImport["city"]]
                : null,
              zipcode: xlsxDataItem[this.requiredColumnsOnImport["zipcode"]]
                ? xlsxDataItem[this.requiredColumnsOnImport["zipcode"]]
                : null,
              country: xlsxDataItem[this.requiredColumnsOnImport["country"]]
                ? xlsxDataItem[this.requiredColumnsOnImport["country"]].toUpperCase()
                : xlsxDataItem[this.requiredColumnsOnImport["country"]],
              contact_type: contact_type,
              entity_type: entity_type,
              voting_categories: boVotingCategories,
              building_lots: boBuildingLots,
              labels: {
                lastname: this.requiredColumnsOnImport["lastname"],
                firstname: this.requiredColumnsOnImport["firstname"],
                city: this.requiredColumnsOnImport["city"],
                address: this.requiredColumnsOnImport["address"],
                zipcode: this.requiredColumnsOnImport["zipcode"],
              },
            });
          }
        });
        if (
          this.invalidCountryCodes.length > 0 ||
          this.invalidContactTypes.length > 0 ||
          this.invalidGenderTypes.length > 0 ||
          this.invalidEntityTypes.length > 0
        ) {
          this.$bvModal.show("modal-required-columns-on-import");
          return;
        }
        await BuildingOwnerMW.IMPORT(buildingOwners, this.building.id)
          .then(res => {
            if (res.response.data.error) {
              this.$swal(
                this.alertWarning(
                  "Problème d'importation",
                  "Pour certains utilisateurs, les champs suivants sont manquants : " +
                    res.response.data.error
                )
              );
            }
          })
          .catch(err => {
            console.log("error", err);
          });
      }
    },
    addOrEditAddRecipient(buildingOwnerId) {
      this.buildingOwnerId = buildingOwnerId;
      this.$bvModal.show("modal-add-recipient");
    },
    cancelPressed() {
      this.viewAdd = false;
      this.viewEdit = false;
      this.buildingOwnerId = null;
      this.loadBuildingOwners();
    },
    addPressed() {
      this.viewAdd = true;
    },
    editPressed(buildingOwnerId) {
      this.buildingOwnerId = buildingOwnerId;
      this.viewEdit = true;
    },
    deletePressed(buildingOwnerId) {
      let self = this;
      this.$swal(this.alertQuestion())
        .then(res => {
          if (res.value) {
            this.isLoading = true;
            let buildingOwnerIndex = this.$_.findIndex(this.buildingOwners, item => {
              return item.id == buildingOwnerId;
            });
            let buildingOwnerItemIndex = this.$_.findIndex(this.buildingOwnersItems, item => {
              return item.id == buildingOwnerId;
            });
            if (buildingOwnerIndex != -1 || buildingOwnerItemIndex != -1) {
              BuildingOwnerMW.CUSTOM_DELETE(buildingOwnerId)
                .then(res2 => {
                  this.isLoading = false;
                  if (res2.response.data.deleted) {
                    BuildingOwnerORM.delete(buildingOwnerId);
                    // Get current buildingOwners
                    let buildingOwners = BuildingOwnerORM.query()
                      .where("building_id", this.building.id)
                      .get();
                    // Update Building in order to know on step 6 how many buildingOwners are
                    self.$emit("updateBuilding", "building_owners", buildingOwners);
                    this.processAndSetTableNeededData();
                  } else {
                    this.$swal(
                      this.alertWarning(
                        undefined,
                        "Ce propriétaire d'immeuble ne peut pas être supprimé car il a déjà un mandat dans une convocation !"
                      )
                    );
                  }
                })
                .catch(err => {
                  this.isLoading = false;
                });
            } else {
              this.isLoading = false;
            }
          }
        })
        .catch(err => {
          this.$swal(this.alertError());
        });
    },
    totalPartsPerBuildingOwner(parts) {
      let partsBO = 0;
      parts.forEach(part => {
        partsBO += part.parts;
      });
      return partsBO;
    },
    toggleDetails(parts) {
      parts._showDetails = !parts._showDetails;
    },
    openModalAGResetUserPassword(buildingOwnerUsername) {
      this.buildingOwnerUsername = buildingOwnerUsername;
      this.$bvModal.show("modal-ag-reset-user-password");
    },
    closeModalAGResetUserPassword() {
      this.$bvModal.hide("modal-ag-reset-user-password");
    },
    userPasswordReseted() {
      this.processAndSetTableNeededData();
      this.closeModalAGResetUserPassword();
    },
    async openModalDepartBuildingLot(buildingOwnerId) {
      var res = await BuildingOwnerMW.CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED({
        oldOwnerId: buildingOwnerId,
      });

      if (res.response) {
        this.buildingOwnerId = buildingOwnerId;
        this.$bvModal.show("modal-depart-building-lot");
      } else {
        this.$swal({
          icon: "warning",
          title: "Impossible de quitter le lot car ce propriétaire a une réunion en cours !",
          text: "Réinitialiser la réunion avant de faire l'opération",
          showConfirmButton: true,
          timer: 7000,
        });
      }
    },
    closeModalDepartBuildingLot() {
      this.$bvModal.hide("modal-depart-building-lot");
    },
    async refetchTableDataAfterDepartBuildingLot() {
      this.closeModalDepartBuildingLot();

      this.isLoading = true;
      BuildingOwnerORM.deleteAll();
      RecipientORM.deleteAll();
      await BuildingOwnerMW.FETCH(this.building.id);
      await RecipientMW.GET_BY_BUILDING_ID(this.building.id);
      this.processAndSetTableNeededData();
      this.isLoading = false;
    },
    closeModalAddRecipient() {
      this.$bvModal.hide("modal-add-recipient");
    },
    getRecipientsData(buildingOwnerId) {
      return this.recipients.filter(recipient => recipient.building_owner_id === buildingOwnerId);
    },
    deleteAllBuildingOwners() {
      this.$swal(this.alertQuestion()).then(res => {
        if (res.value) {
          this.$store.state.showLoaderOverlay = true;
          BuildingOwnerMW.BULK_DELETE(this.building.id)
            .then(() => {
              BuildingOwnerORM.deleteAll();
              this.processAndSetTableNeededData();
              this.$store.state.showLoaderOverlay = false;
            })
            .catch(err => {
              console.error(err);
              this.$swal(this.alertError());
              this.$store.state.showLoaderOverlay = false;
            });
        }
      });
    },
    checkCountry(xlsxDataItem) {
      if (xlsxDataItem[this.requiredColumnsOnImport["country"]]) {
        let found = this.$_.find(this.allCountries, country => {
          return (
            country.countryCode.toUpperCase() ==
            xlsxDataItem[this.requiredColumnsOnImport["country"]].toUpperCase()
          );
        });
        if (found === undefined) {
          this.invalidCountryCodes.push(xlsxDataItem[this.requiredColumnsOnImport["country"]]);
        }
      } else {
        this.invalidCountryCodes.push(this.requiredColumnsOnImport["country"]);
      }
    },
    checkGender(xlsxDataItem) {
      let gender = null;
      if (xlsxDataItem[this.requiredColumnsOnImport["gender"]]) {
        let found = this.$_.find(this.genderOptions, genderType => {
          return xlsxDataItem[this.requiredColumnsOnImport["gender"]] == genderType.excelKey;
        });
        if (found === undefined) {
          this.invalidGenderTypes.push(xlsxDataItem[this.requiredColumnsOnImport["gender"]]);
        }
        this.genderOptions.forEach(genderType => {
          if (xlsxDataItem[this.requiredColumnsOnImport["gender"]] == genderType.excelKey) {
            gender = genderType.value;
          }
        });
      }
      return gender;
    },
    checkContactType(xlsxDataItem) {
      // NOTE: DEV-5308: Default contactType is contactTypes.courrier_postal or contactTypes.email
      const hasEmail = !!xlsxDataItem[this.requiredColumnsOnImport["email"]];
      let contact_type = hasEmail ? this.contactTypes.email : this.contactTypes.courrier_postal;
      if (xlsxDataItem[this.requiredColumnsOnImport["contact_type"]]) {
        let found = this.$_.find(this.allContactTypeOptions, contactType => {
          return xlsxDataItem[this.requiredColumnsOnImport["contact_type"]] == contactType.excelKey;
        });
        if (found === undefined) {
          this.invalidContactTypes.push(xlsxDataItem[this.requiredColumnsOnImport["contact_type"]]);
        } else {
          if (found.value == this.contactTypes.lre) {
            // NOTE: DEV-5308: Return default contactTypes.courrier_postal or contactTypes.email
            return hasEmail ? this.contactTypes.email : this.contactTypes.courrier_postal;
          } else {
            return found.value;
          }
        }
      }
      return contact_type;
    },
    checkEntityType(xlsxDataItem) {
      let entity_type = null;
      if (xlsxDataItem[this.requiredColumnsOnImport["entity_type"]]) {
        let found = this.$_.find(this.entityTypeOptions, entityType => {
          return xlsxDataItem[this.requiredColumnsOnImport["entity_type"]] == entityType.excelKey;
        });
        if (found === undefined) {
          this.invalidContactTypes.push(xlsxDataItem[this.requiredColumnsOnImport["entity_type"]]);
        }
        this.entityTypeOptions.forEach(entityType => {
          if (xlsxDataItem[this.requiredColumnsOnImport["entity_type"]] == entityType.excelKey) {
            entity_type = entityType.value;
          }
        });
      }
      return entity_type;
    },
    async search() {
      if (this.isLoading) return;
      this.hasSearchInputBeenReseted = false;

      this.isLoading = true;
      await this.getBuildingOwnersPerPage();
      this.processAndSetTableNeededData();
      this.isLoading = false;
    },
    focusSearch() {
      this.isSearchInputFocused = true;
    },
    unfocusSearch() {
      this.isSearchInputFocused = false;
    },
    async resetSearch() {
      this.hasSearchInputBeenReseted = true;
      this.isSearchInputFocused = false;

      this.searchParams = "";

      this.isLoading = true;
      await this.getBuildingOwnersPerPage();
      this.processAndSetTableNeededData();
      this.isLoading = false;
    },
    getLreAgreement(buildingOwnerId) {
      const buildingOwner = this.$_.find(this.computedBuildingOwners, bo => {
        return bo.id == buildingOwnerId;
      });
      return buildingOwner.settings && buildingOwner.settings.lre_agreement != undefined
        ? buildingOwner.settings.lre_agreement
        : false;
    },
    getLreRefusal(buildingOwnerId) {
      const buildingOwner = this.$_.find(this.computedBuildingOwners, bo => {
        return bo.id == buildingOwnerId;
      });
      return buildingOwner.settings && buildingOwner.settings.lre_refusal != undefined
        ? buildingOwner.settings.lre_refusal
        : false;
    },
    async getBuildingsList() {
      BuildingORM.api()
        .BUILDINGS_LIST()
        .then(res => {
          this.buildings = [];

          let apiBuildings = res.response.data ? res.response.data["hydra:member"] : [];
          apiBuildings.forEach(item => {
            if (item.id == this.building.id) {
              return;
            }
            this.buildings.push({
              value: item.id,
              text: item.name,
            });
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    getBuildingAslName(id) {
      let found = this.$_.find(this.buildings, building => {
        return id == building.value;
      });
      if (found !== undefined) {
        return found.text;
      } else {
        return "";
      }
    },
    async checkAllLreConsent() {
      // Fetch ALL building owners for the current building (not just current page)
      this.$store.state.showLoaderOverlay = true;

      try {
        // Get all building owners from the database
        await BuildingOwnerMW.FETCH(this.building.id);

        // Get all building owners from the store
        const allBuildingOwners = BuildingOwnerORM.query()
          .where("building_id", this.building.id)
          .get();

        let buildingOwnersToUpdate = [];

        for (const buildingOwner of allBuildingOwners) {
          // Skip if no email
          if (!buildingOwner.email) continue;

          // Skip if has explicitly refused LRE consent
          if (buildingOwner.settings && buildingOwner.settings.lre_refusal) continue;

          // Initialize settings if undefined
          if (!buildingOwner.settings) {
            buildingOwner.settings = {};
          }

          // Set LRE agreement to true
          buildingOwner.settings.lre_agreement = true;
          buildingOwner.settings.lre_agreement_media = null;

          buildingOwnersToUpdate.push({
            id: buildingOwner.id,
            contact_type: this.contactTypes.email, // Set preferred channel to email
            settings: {
              lre_agreement: true,
              lre_agreement_media: null,
            },
          });
        }

        if (buildingOwnersToUpdate.length > 0) {
          await BuildingOwnerMW.SET_LRE_AGREEMENT(buildingOwnersToUpdate);

          // Refresh the current page data
          await this.loadBuildingOwners();

          this.$bvToast.toast(
            `${buildingOwnersToUpdate.length} propriétaire(s) activé(s) avec consentement LRE et canal email.`,
            {
              title: "Activation réussie",
              variant: "success",
              solid: true,
            }
          );
        } else {
          this.$bvToast.toast(
            "Aucun propriétaire à activer (aucun email ou tous ont refusé le consentement).",
            {
              title: "Information",
              variant: "info",
              solid: true,
            }
          );
        }
      } catch (err) {
        console.error("Error in checkAllLreConsent:", err);
        this.$swal(this.alertError());
      } finally {
        this.$store.state.showLoaderOverlay = false;
      }
    },
    async toggleBuildingOwnerLreAgreement(buildingOwnerId, isAgreed) {
      let buildingOwner = BuildingOwnerORM.find(buildingOwnerId);
      buildingOwner.settings.lre_agreement = isAgreed;
      // If setting agreement to true, ensure refusal is false
      if (isAgreed === true) {
        buildingOwner.settings.lre_refusal = false;
      }
      await BuildingOwnerMW.PUT(buildingOwner).catch(err => {
        console.error(err);
      });
    },
    async exportBuildingOwners() {
      try {
        const XLSX = await import("xlsx");

        // Fetch ALL building owners for export
        await BuildingOwnerMW.FETCH(this.building.id);
        await BuildingLotMW.FETCH(this.building.id);
        await VotingCategoryMW.FETCH(this.building.id);

        // Get all building owners from the store
        const allBuildingOwners = BuildingOwnerORM.query()
          .where("building_id", this.building.id)
          .orderBy("lastname")
          .get();

        const allBuildingLots = BuildingLotORM.query()
          .where("building_id", this.building.id)
          .with("building_owner_building_lots.building_owner_voting_rights")
          .get();

        const allVotingCategories = VotingCategoryORM.query()
          .where("building_id", this.building.id)
          .orderBy("slug")
          .get();

        // Prepare export data
        const exportData = [];

        // Process each building owner
        allBuildingOwners.forEach(buildingOwner => {
          // Get lots for this owner
          const ownerLots = [];
          const votingCategoryParts = {};

          // Initialize voting category parts
          allVotingCategories.forEach(vc => {
            votingCategoryParts[vc.slug] = 0;
          });

          allBuildingLots.forEach(buildingLot => {
            buildingLot.building_owner_building_lots.forEach(boBuildingLot => {
              if (boBuildingLot.building_owner_id === buildingOwner.id) {
                ownerLots.push(buildingLot.name);

                // Sum up voting rights per category
                boBuildingLot.building_owner_voting_rights.forEach(votingRight => {
                  const vc = allVotingCategories.find(v => v.id === votingRight.voting_category_id);
                  if (vc) {
                    votingCategoryParts[vc.slug] += votingRight.parts;
                  }
                });
              }
            });
          });

          // Get gender text
          const genderOption = this.genderOptions.find(opt => opt.value === buildingOwner.gender);
          const genderText = genderOption ? genderOption.text : "";

          // Get entity type text
          const entityTypeOption = this.entityTypeOptions.find(
            opt => opt.value === buildingOwner.entity_type
          );
          const entityTypeText = entityTypeOption ? entityTypeOption.text : "";

          // Create a row for each lot
          if (ownerLots.length > 0) {
            ownerLots.forEach(lotName => {
              const row = {
                Lot: lotName,
                Civilité: genderText,
                Nom: buildingOwner.lastname || "",
                Prénom: buildingOwner.firstname || "",
                Email: buildingOwner.email || "",
                Téléphone: buildingOwner.phone || "",
                Adresse: buildingOwner.address || "",
                Complément: buildingOwner.complement || "",
                "Complément 2": buildingOwner.complement2 || "",
                "Code postal": buildingOwner.zipcode || "",
                Ville: buildingOwner.city || "",
                Pays: buildingOwner.country || "",
                "Type d'entité": entityTypeText,
                "Nom d'utilisateur": buildingOwner.username || "",
                "Mot de passe": buildingOwner.password || "",
              };

              // Add voting category columns
              allVotingCategories.forEach(vc => {
                row[vc.name] = votingCategoryParts[vc.slug];
              });

              exportData.push(row);
            });
          } else {
            // No lots - still export the owner
            const row = {
              Lot: "",
              Civilité: genderText,
              Nom: buildingOwner.lastname || "",
              Prénom: buildingOwner.firstname || "",
              Email: buildingOwner.email || "",
              Téléphone: buildingOwner.phone || "",
              Adresse: buildingOwner.address || "",
              Complément: buildingOwner.complement || "",
              "Complément 2": buildingOwner.complement2 || "",
              "Code postal": buildingOwner.zipcode || "",
              Ville: buildingOwner.city || "",
              Pays: buildingOwner.country || "",
              "Type d'entité": entityTypeText,
              "Nom d'utilisateur": buildingOwner.username || "",
              "Mot de passe": buildingOwner.password || "",
            };

            // Add voting category columns
            allVotingCategories.forEach(vc => {
              row[vc.name] = votingCategoryParts[vc.slug];
            });

            exportData.push(row);
          }
        });

        // Create workbook and worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Copropriétaires");

        // Generate filename with building name and date
        const date = new Date().toISOString().split("T")[0];
        const buildingName = this.building.name.replace(/[^a-z0-9]/gi, "_");
        const filename = `Coproprietaires_${buildingName}_${date}.xlsx`;

        // Export file
        XLSX.writeFile(workbook, filename);

        this.$bvToast.toast(`Export réussi: ${exportData.length} ligne(s) exportée(s)`, {
          title: "Export terminé",
          variant: "success",
          solid: true,
        });
      } catch (err) {
        console.error("Error exporting building owners:", err);
        this.$swal(this.alertError("Erreur lors de l'export"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bo-lot {
  font-size: 0.9rem;
}
.bo-parts {
  font-size: 0.9rem;
}
.bo-parts-total {
  font-size: 1rem;
}
</style>
